import { useEffect } from 'react';

const STYLE_ID = 'egmg-chat-offset';
// Lifts the LeadConnector launcher above the sticky mobile contact bar (64px + safe area).
const CSS = `@media (max-width: 1023px) {
  #lc_text-widget, #lc_text-widget--btn, .lc_text-widget { bottom: calc(84px + env(safe-area-inset-bottom)) !important; }
}`;

function inject() {
  const root = document.querySelector('chat-widget')?.shadowRoot;
  if (!root || root.getElementById(STYLE_ID)) return Boolean(root);
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = CSS;
  root.appendChild(style);
  return true;
}

export default function ChatWidgetTweaks() {
  useEffect(() => {
    if (inject()) return undefined;
    let tries = 0;
    const timer = setInterval(() => { if (inject() || ++tries > 60) clearInterval(timer); }, 500);
    window.addEventListener('LC_chatWidgetLoaded', inject);
    return () => { clearInterval(timer); window.removeEventListener('LC_chatWidgetLoaded', inject); };
  }, []);
  return null;
}
